<template>
  <b-col lg="10">
      <b-form-group class="text-left"
                    label-class="font-weight-bold pt-0"
                    :label="label">
        <p v-if="comment !== ''"><small>{{comment}}</small></p>
        <b-list-group horizontal style="overflow-y: auto;">
          <b-list-group-item v-for="(item, index) in answers"
                             button
                             class="text-center"
                             @click="selectItem(index)"
                             :active="isActive(index)"
                             :key="item.value">
            {{item.value}}
          </b-list-group-item>
        </b-list-group>
        <FormButtonBlock
          v-model="selectedIndex"
          @action-selected="actionSelected"/>
      </b-form-group>
    </b-col>
</template>

<script>
import FormButtonBlock from './FormButtonBlock'
import _ from 'lodash'
export default {
  name: 'FormRadioHorisontal',
  components: {FormButtonBlock},
  props: {
    label: {
      type: String,
      default: ''
    },
    comment: {
      type: String,
      default: ''
    },
    codeQuestion: {
      type: String,
      default: ''
    },
    ranges: {
      type: Object,
      default: () => {}
    },
    additionalAnswers: {
      type: Array,
      default: () => {}
    },
    value: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      selected: '',
      selectedIndex: -2,
      answers: []
    }
  },
  mounted () {
    let i = this.ranges.from
    for (i; i <= this.ranges.to; i++) {
      this.answers.push({value: i, point: i})
    }
  },
  beforeMount () {
    const point = this.value[this.codeQuestion]
    if (!_.isUndefined(point)) {
      this.updateStatus(point)
    }
  },
  watch: {
    value (val) {
      const point = val[this.codeQuestion]
      if (!_.isEmpty(point) && !_.isUndefined(point)) {
        this.updateStatus(point)
      }
    },
    selectedIndex (val) {
      if (!_.isUndefined(val)) {
        if (val === -1) {
          val = 99
        }
        if (val >= 0 && val !== 99) {
          val = val + 1
        }
        const item = {codeQuestion: this.codeQuestion,
          value: val}
        this.$emit('action-output', item)
      }
    }
  },
  methods: {
    isActive (index) {
      return index === this.selectedIndex
    },
    selectItem (index) {
      this.selectedIndex = index
    },
    actionSelected () {
      this.selectedIndex = -1
    },
    updateStatus (point) {
      if (point === 99) {
        this.selectedIndex = -1
      } else if (this.ranges.from >= point <= this.ranges.to) {
        this.selectedIndex = point - 1
      }
    }
  }
}
</script>

<style scoped>
  /*.list-group-horizontal .list-group-item  .list-group-item {*/
  /*  max-height: 61px!important;*/
  /*}*/
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-button {
    background: #888
  }
  ::-webkit-scrollbar-track-piece {
    background: #ccc
  }
  ::-webkit-scrollbar-thumb {
    height: 2px;
    background: #888
  }
  button, [type="button"] {
    -webkit-appearance: button;
    height: 10% !important;
    width: 10% !important;
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/FormRadioHorisontal.vue